import { SHOW_MESSAGE_TOAST } from '../actionTypes/common';

export const sendMessageToastAction = key => {
  return {
    type: SHOW_MESSAGE_TOAST,
    payload: { key },
  };
};
